<template>
  <div>
    <div class="mt-2" style="font-size: 13px">
      <p>Bem vindo à temporada FLL Into-Orbit!</p>
      <b>Competências e habilidades gerais de um juiz:</b> Gostar de interagir
      com crianças, estar habilitado para avaliar crianças e dar feedbacks com
      didática; possuir habilidade para trabalhar em grupo; ter foco em
      resultados e cumprimento de prazos; ter disponibilidade para atuar em
      tempo integral nos evento e possuir espírito de inovação.
    </div>

    <!-- Events -->
    <div
      v-if="events && events.length"
      v-loading="loadingEvents"
      class="mt-4 mb-4"
    >
      <div class="body-1 mb-2 tournament-dark-grey--text">
        Escolha um ou mais torneios para participar
      </div>
      <el-checkbox-group
        v-model="localSelectedEvents"
        class="list-select"
        @change="$emit('updateSelectedEvent', $event)"
      >
        <el-collapse accordion>
          <el-collapse-item v-for="event in events" :key="event._id">
            <template #title>
              <el-checkbox
                :key="event._id"
                :label="event._id"
                :name="event.name"
                :disabled="event.disabled"
              >
                {{ event.name }}
              </el-checkbox>
              <v-icon light class="cursor-pointer" style="font-size: 14px">
                info
              </v-icon>
            </template>
            <div v-if="event">
              <!-- Season -->
              <div
                v-if="
                  event.event && event.event.season && event.event.season.label
                "
                class="mb-2"
              >
                <div class="bold">
Temporada:
</div>
                {{ event.event.season.label }}
              </div>

              <!-- Location -->
              <div
                v-if="
                  event.event
                    && event.event.address
                    && event.event.address.address
                "
                class="mb-2"
              >
                <div class="bold">
Local:
</div>
                {{ event.event.location ? `${event.event.location} - ` : ""
                }}{{ event.event.address.address
                }}{{
                  event.event.address.number
                    ? `, ${event.event.address.number}`
                    : ""
                }}
              </div>

              <!-- City -->
              <div
                v-if="
                  event.event && event.event.address && event.event.address.city
                "
                class="mb-2"
              >
                <div class="bold">
Cidade:
</div>
                {{ event.event.address.city }}, {{ event.event.address.state }}
              </div>

              <!-- Event Date -->
              <div
                v-if="
                  event.event && event.event.startDate && event.event.endDate
                "
                class="mb-2"
              >
                <div class="bold">
Data do evento:
</div>
                {{
                  event.event.startDate
                    | FormatEventDate(event.event.endDate, "long")
                }}
              </div>

              <!-- Notes -->
              <div v-if="event.registration && event.registration.notes">
                <div class="bold">
Observações da organização:
</div>
                <div>{{ event.registration.notes }}</div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-checkbox-group>
    </div>

    <!-- Judge area -->
    <div v-if="judgeArea && judgeArea.length" class="mb-4">
      <div class="body-1 mb-2 tournament-dark-grey--text">
        Descreva suas áreas de interesse
      </div>
      <el-checkbox-group
        v-model="localSelectedJudgeArea"
        class="list-select"
        @change="$emit('updateSelectedJudgeArea', $event)"
      >
        <el-collapse accordion>
          <el-collapse-item v-for="area in judgeArea" :key="area.value">
            <template #title>
              <el-checkbox
                :key="area.value"
                :label="area.value"
                :name="area.label"
              >
                {{ area.label }}
              </el-checkbox>
              <v-icon light class="cursor-pointer" style="font-size: 14px">
                info
              </v-icon>
            </template>
            <div>{{ area.text }}</div>
          </el-collapse-item>
        </el-collapse>
      </el-checkbox-group>
    </div>
  </div>
</template>

<script>
export default {
  name: "JudgeRegistrationForm",

  props: {
    selectedJudgeArea: {
      type: Array,
    },

    events: {
      type: Array,
    },

    selectedEvents: {
      type: Array,
    },

    loadingEvents: {
      type: Boolean,
    },
  },
  data() {
    return {
      localSelectedJudgeArea: [],
      localSelectedEvents: [],

      judgeArea: [
        {
          label: "Voluntário Geral",
          value: "volunteer",
          text: "Trabalhar auxiliando em diversas atividades durante o torneio, como conferir robôs, ajudar na organização das equipes e auxiliar juizes.",
        },
        {
          label: "Juiz de Arena",
          value: "juiz-arena",
          text: "Desejável ter conhecimento de peças e componentes LEGO. Entendimento das regras e missões da temporada. Ativo, predisposto a trabalhar em pé, capacidade de concentração e habilidades de lidar com crianças e adolescentes. É necessário ter condições para participar de agito, barulho e trabalhar com os diversos  públicos (alunos, técnicos, pais, visitantes, etc.)",
        },
        {
          label: "Juiz de Projeto de Inovação",
          value: "juiz-projeto-pesquisa",
          text: "Desejável ter experiência com processos de pesquisa, seja com iniciação científica, pós-graduação ou procedimentos inovadores de produtos em empresas, preferencialmente relacionados à tecnologia. Para o Projeto de Pesquisa, o juíz deve ter ensino superior completo.",
        },
        {
          label: "Juiz de Core Values",
          value: "juiz-core-values",
          text: "Desejável ter experiência com relações humanas e/ou educação. Pessoas que atuam nas áreas (não excluindo outras) da psicologia, pedagogia, filosofia, história, artes e letras tendem a desempenhar bem o papel de juiz na área de Core.",
        },
        {
          label: "Juiz de Design do Robô",
          value: "juiz-design-robo",
          text: "Desejável ter experiência sobre construção e programação de robôs. Pessoas que atuam nas áreas (não excluindo outras áreas) de mecânica, eletrônica, engenharia, eletrotécnica, automação, informática e áreas afins.",
        },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Judge/RegistrationForm/index.vue